module.exports = __webpack_public_path__ + "img/20260309_3.913fe82e.jpg";